import { AppError, authFetch } from "../utils/utils";
import useDataAuth from "./useDataAuth";

export default function useLoginCount() {
  const { data, error } = useDataAuth((token, signal) =>
    fetchLoginCount(token, signal)
  );

  // Ensure we return a plain number (or undefined initially)
  return { loginCount: data, error };
}

async function fetchLoginCount(token: string, signal: AbortSignal): Promise<number> {
  const res = await authFetch(token, `/api/get-login-count`, { signal });
  const { loginCount, error } = await res.json();

  if (error !== undefined) throw new AppError(res.status, error as string);

  // loginCount.loginCount is a string — parse it to number
  return parseInt(loginCount.loginCount, 10);
}
